export function canCreateConfirm(offer, currentUser) {
  if (!offer) return false;

  const alreadyConfirmed = offer.confirmed || offer.is_confirm;

  return !alreadyConfirmed
    && offer.state !== 'declined'
    && (currentUser?.can_create_calendar_event !== false);
}

export default canCreateConfirm;
